module.exports = __webpack_public_path__ + "img/provinceApply.d50041fd.png";